module.exports = __webpack_public_path__ + "0f90c516b86392022b13bd195ce04de0.png";